import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { PersonGender } from '../../models/person-genders/person-gender';
import { HttpClientService } from '../http-client/http-client.service';

@Injectable()
export class PersonGenderService {

    public personGenders: PersonGender[];
    public personGendersObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.personGenders = [];
        this.personGendersObject = {};
    }

    public getAll(): Observable<PersonGender[]> {
        if (!!this.personGenders && this.personGenders.length > 0) {
            return Observable.create((observer: Subscriber<PersonGender[]>) => {
                observer.next(this.personGenders);
                observer.complete();
            });
        }
        const url = 'persongenders/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.personGenders = r.Result;
                this.personGendersObject = this.personGenders.reduce((result, st) => {
                    result[String(st.id)] = result[String(st.id)] || {};
                    result[String(st.id)] = st;
                    return result;
                }, {});
            } else {
                console.error('personGendersService > getAll > response', r);
            }
            return this.personGenders;
        }).catch(this.handleError);
    }

    /*public getById(id: number): Observable<StoreType> {
        if (!!this.storeTypes && this.storeTypes.length > 0 && !!this.storeTypes.find(st => st.id == id)) {
            return Observable.create((observer: Subscriber<StoreType>) => {
                observer.next(this.storeTypes.find(st => st.id == id));
                observer.complete();
            });
        }
        const url = 'store-types/id/' + id;
        return this.http.get(url).map(response => {
            let r = response.json();
            let storeType = null;
            if (r.resultCode === 1) {
                storeType = r.result;
                let alreadyExist = this.storeTypes.find(st => st.id == storeType.id);
                if (!alreadyExist) {
                    this.storeTypes.push(storeType);
                    this.storeTypesObject[storeType.id] = storeType;
                }
            } else {
                console.error('StoreTypeService > getById > response', r);
            }
            return storeType;
        }).catch(this.handleError);
    }

    public add(name: string, description: string) {
        const url = 'store-types/add';
        return this.http.post(url, {
            Name: name,
            Description: description
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(id: number, name: string, description: string) {
        const url = 'store-types/edit';
        return this.http.put(url, {
            Id: id,
            Name: name,
            Description: description
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: number) {
        const url: string = 'store-types/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }*/

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/person-genders/person-gender.service.ts